<template>
  <div class="point" :style="{ left: coordinate.coordX(lng) + 'px', top: coordinate.coordY(lat) + 'px' }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    lng: { type: Number, required: true },
    lat: { type: Number, required: true },
  },
  inject: ['getCoordinate'],
  computed: {
    coordinate() {
      return this.getCoordinate()
    }
  }
};
</script>

<style scoped>
.point {
  position: absolute;
  transform: translate(-50%, -50%);
}
</style>
